<template>
  <div>
    <b-row class="introSrcoll justify-content-center my-5">
      <b-col class="img-content" cols="8" md="3">
        <div class="img-wrap img-hovor">
          <img width="100%" height="100%" :src="intro.sysFilePhotoIdUrl" />
        </div>
      </b-col>
      <div class="arrows miniArrows">
        <img
          class="arrow left"
          @click="pre"
          src="../assets/scroll-left-arrow.png"
        />
        <img
          class="arrow right"
          @click="next"
          src="../assets/scroll-right-arrow.png"
        />
      </div>
      <b-col cols="12" md="8" style="padding-bottom: 2rem">
        <b-row class="intro-content h-100" style="margin-top: 2rem">
          <b-col cols="12" style="min-height: 4.2rem"
            ><div>{{ intro.message }}</div></b-col
          >
          <b-col cols="12" align-self="end">
            <div style="display: flex; justify-content: flex-end">
              <div v-if="intro.sysFileAutographUrl" class="sysFileAnto">
                <!-- 签名照 -->
                <img
                  width="100%"
                  height="100%"
                  :src="intro.sysFileAutographUrl"
                />
              </div>
              <span class="donorName">{{ intro.name }}</span>
            </div>
          </b-col>
          <b-col cols="12">
            <div style="text-align: right">
              {{ intro.rank }}
            </div>
          </b-col>
        </b-row>
      </b-col>
      <div class="arrows pcArrows">
        <img
          class="arrow left"
          @click="pre"
          src="../assets/scroll-left-arrow.png"
        />
        <img
          class="arrow right"
          @click="next"
          src="../assets/scroll-right-arrow.png"
        />
      </div>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    introList: {
      type: Array,
      default: () => [],
    },
    byYear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      introIndex: 0,
      intro: {},
    };
  },
  watch: {
    introList(val) {
      this.intro = val[this.introIndex];
      console.log("任务轮播数据啦啦啊阿拉阿拉啦啦啦啦啦", this.intro);
    },
    intro(val) {
      console.log("intro", val);
    },
  },

  methods: {
    toDetail(id) {
      this.$router.push(`/donors/detail?id=${id}`);
    },
    pre() {
      this.introIndex--;
      if (this.introIndex < 0) {
        this.introIndex = this.introList.length - 1;
      }
      this.intro = this.introList[this.introIndex];
    },
    next() {
      this.introIndex++;
      if (this.introIndex > this.introList.length - 1) {
        this.introIndex = 0;
      }
      this.intro = this.introList[this.introIndex];
    },
  },
};
</script>
<style lang="scss" scoped>
.img-wrap {
  width: 80%;
}
.introSrcoll::v-deep {
  position: relative;
  background: #f8f8f8;
  padding: 1rem;
  .arrows {
    font-size: 1.5rem;
    position: absolute;
    left: 0;
    top: 50%;
    justify-content: space-between;
    width: 96%;
    right: 0;
    margin: auto;
    display: flex;
  }
  .arrow {
    width: 1rem;
    height: auto;
    cursor: pointer;
  }
  .sysFileAnto {
    width: 40%;
    height: 7rem;
  }
  .img-content {
    position: unset;
    align-items: center;
    display: flex;

    .miniArrows {
      visibility: hidden;
    }
    .pcArrows {
      visibility: visible;
    }
  }
  .intro-content {
    font-size: 1.2rem;
    color: #666666;
    line-height: 2.3rem;
    overflow: hidden;
  }
  .donorName {
    display: flex;
    align-items: flex-end;
  }
}

@media (max-width: 768px) {
  .introSrcoll::v-deep {
    position: unset;
    padding-bottom: 20rem;
    margin-bottom: 5rem;
    .img-wrap {
      width: 100%;
    }
    .sysFileAnto {
      width: 85%;
      height: 7rem;
    }
    .img-content {
      position: relative;
      padding: 0;
      .arrows {
        position: absolute;
        left: -17%;
        top: 50%;
        width: 134%;
      }

      .donorName {
        position: relative;
        top: 1.5rem;
        left: -1rem;
      }
      .miniArrows {
        visibility: visible;
      }
    }
    .arrows {
      font-size: 1.5rem;
      position: absolute;
      left: 0;
      top: 60%;
      justify-content: space-between;
      width: 85%;
      right: 0;
      margin: auto;
      display: flex;
    }
    .pcArrows {
      visibility: hidden;
    }
  }
}
</style>
